import { cn } from '../../lib/cn';
import { Card } from './Card';

type Props = {
  label: string;
  value: string | number;
  hint?: string;
  trend?: string;
  trendUp?: boolean;
  className?: string;
};

export function KpiCard({ label, value, hint, trend, trendUp, className }: Props) {
  return (
    <Card className={className}>
      <p className="text-xs font-medium uppercase tracking-wide text-slate-500">{label}</p>
      <p className="mt-1 text-2xl font-semibold text-slate-900 dark:text-slate-100">{value}</p>
      {trend && (
        <p className={cn('mt-1 text-xs', trendUp ? 'text-success-600' : 'text-error-600')}>{trend}</p>
      )}
      {hint && <p className="mt-1 text-xs text-slate-400">{hint}</p>}
    </Card>
  );
}
